import store from 'store';
import moment from "moment/moment";
import 'moment/locale/ja';

moment().locale('ja');

const ENTER = 13;
const MOVILE_NAV_MOVE_X = 380;

export default {
    updateAreaAction(id) {
        this.setState({areaId: id});
    },
    updateToggleMobileNavAction() {
        this.setState({showMobileNav: !this.state.showMobileNav});
    },
    execKeywordSearch(e) {
        if (e.keyCode === ENTER && e.target.value) {
            window.location.href = "//bangumi.org/search?area_code=" + this.state.areaId + "&q=" + encodeURIComponent(e.target.value);
        }
    },
    disableSubmit(e) {
        e.preventDefault();
    },
    areaChange(e) {
        this.updateAreaAction(e.target.value);
        store.set('area', {id: e.target.value})
        this.props.history.push('/schedule/' + e.target.value);
    },
    showMobileNav(e) {
        e.preventDefault();
        var f = document.getElementById('mobile_nav');
        f.style.transform += 'translateX(' + MOVILE_NAV_MOVE_X + 'px)';
        this.updateToggleMobileNavAction();
    },
    hideMobileNav(e) {
        e.preventDefault();
        var f = document.getElementById('mobile_nav');
        f.style.transform += 'translateX(' + (MOVILE_NAV_MOVE_X * -1) + 'px)';
        this.updateToggleMobileNavAction();
    },
    epgUrl() {
        return "//bangumi.org/epg/td?broad_cast_date=" + moment().format("YYYYMMDD") + "&ggm_group_id=" + this.state.areaId + "&from=gorin";
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/header.js